import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "section content-container" }
const _hoisted_3 = { class: "container is-fluid" }
const _hoisted_4 = { class: "report-container" }
const _hoisted_5 = { class: "report-container island" }
const _hoisted_6 = { class: "report-container island" }

import FlowEscalationRateCharts from '@/features/reports/components/flows/FlowEscalationRateCharts.vue';
import FlowEngagementCharts from '@/features/reports/components/flows/FlowEngagementCharts.vue';
import FlowTotalsCharts from '@/features/reports/components/flows/FlowTotalsCharts.vue';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from 'vue';

interface ReportsLoaded {
  totals: boolean;
  engagement: boolean;
  escalation: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowsReports',
  setup(__props) {

const store = useStore();
const selectedDateOption = computed(() => store.getters.selectedDateOption);
const selectedFlowId = computed(() => store.getters.selectedFlowId);

const setReportLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const reportIsLoaded = ref<ReportsLoaded>({
  totals: false,
  engagement: false,
  escalation: false,
});

watch([selectedDateOption, selectedFlowId], () => {
  resetLoadingStatus();
  setReportLoading(true);
});

onMounted(() => setReportLoading(true));

function handleReportLoad(type: keyof ReportsLoaded) {
  reportIsLoaded.value[type] = true;
  if (reportIsLoaded.value.totals && reportIsLoaded.value.engagement && reportIsLoaded.value.escalation) {
    setReportLoading(false);
  }
}

function resetLoadingStatus() {
  reportIsLoaded.value = {
    totals: false,
    engagement: false,
    escalation: false,
  };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(FlowTotalsCharts, {
            onLoaded: _cache[0] || (_cache[0] = ($event: any) => (handleReportLoad('totals')))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FlowEngagementCharts, {
            onLoaded: _cache[1] || (_cache[1] = ($event: any) => (handleReportLoad('engagement')))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(FlowEscalationRateCharts, {
            onLoaded: _cache[2] || (_cache[2] = ($event: any) => (handleReportLoad('escalation')))
          })
        ])
      ])
    ])
  ]))
}
}

})